<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                is_default: 0,
                currency: 'JPY',
            }"
            :filters-default="{
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 名前', value: 'name', },
                        { text: '▼ 名前', value: '-name' },
                        { text: '▲ 単価', value: 'price', },
                        { text: '▼ 単価', value: '-price' },
                    ],
                },
            ]"
            filters-q-placeholder="保存名、商品名称、HSコード"
            form-modal-id="shipping_item"
            search-action="shipping_item/index"
            item-id="id"
            @after-save="onAfterSave"
            >
            <template v-slot:form="{ form, init }">
                <ShippingItem :model="form" :init="init"></ShippingItem>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="6" class="align-self-center">
                    <p class="mb-1">
                        <span v-if="item.is_default">
                            ※初期値
                        </span>
                    </p>

                    <p v-if="item.name">
                        {{ item.name }}
                    </p>
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <div v-if="item.product">
                        商品名称：{{ item.product }}
                    </div>
                    <div v-if="item.hs_code">
                        HSコード：{{ item.hs_code }}
                    </div>
                    <div v-if="item.price">
                        単価：{{ item.currency }} {{ item.price | BaseNumberFormatter }}
                    </div>
                    <div v-if="item.country">
                        原産国：{{ item.country }}
                    </div>
                    <div v-if="item.quantity">
                        数量：{{ item.quantity }}
                    </div>
                </b-col>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import ShippingItem from '@/components/ShippingItem.vue'

export default {
    components: {
        GridPage,
        ShippingItem,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        onAfterSave() {
            this.$refs.gridPage.search()
        },
    },
}
</script>

